export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pt": {
        "project-name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome do projeto"])},
        "create-project": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vamos lá"])},
        "create-app": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Criar novo projeto"])},
        "select-default-item": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecione uma opção"])},
        "project-goal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Para qual finalidade o projeto será usado?"])},
        "tutorial-text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tutorial: Criando e configurando app do zero"])}
      }
    }
  })
}